<script>
import { NConfigProvider } from 'naive-ui'
import { enUS, dateEnUS } from 'naive-ui'

import homeLayout from "./components/layouts/homeLayout.vue";
import workspaceLayout from "./components/layouts/workspaceLayout.vue";
import emptyLayout from "./components/layouts/emptyLayout.vue";
import dashboardLayout from "./components/layouts/dashboardLayout.vue";
import userCenterLayout from "./components/layouts/userCenterLayout.vue";

import message from "./components/global/message.vue";  // 在window上绑定message, dialog的功能

export default {
    components: {
        workspaceLayout,
        emptyLayout,
        homeLayout,
        dashboardLayout,
        userCenterLayout,
        NConfigProvider,

        message
    },
    data () {
        return {
            enUS,
            dateEnUS
        }
    },
    computed: {
        layout () {
            return this.$route.meta.layout
        }
    }
}
</script>

<template>
    <!-- App.vue -->
    <n-config-provider :locale="enUS" :date-locale="dateEnUS">
        <n-dialog-provider>
            <n-message-provider>
                <n-notification-provider>
                    <message></message>

                    <component :is="layout">

                    </component>

                </n-notification-provider>
            </n-message-provider>
        </n-dialog-provider>
    </n-config-provider>

</template>

<style scoped>
html body {
    height: 100%;
}
</style>
